






















































import { Component, Vue, Watch } from "vue-property-decorator";
import { Media } from "@/types";
import { mapPreferences } from "vue-preferences";
import axios from "@/plugins/axios";
import { mapGetters } from "vuex";
import MediaCard from "@/components/Media/MediaCard.vue";
import AnimeImporter from "@/components/AnimeSelector/AnimeImporter.vue";
import MugenScroll from "vue-mugen-scroll";

@Component({
  components: { AnimeImporter, MediaCard, MugenScroll },
  computed: {
    ...mapPreferences({ ampm: { defaultValue: true } }),
    ...mapGetters(["isLoggedIn", "isAdmin"])
  }
})
export default class MediaList extends Vue {
  medias: Media[] = [];
  loading = false;
  endPage = false;
  page = 0;
  search = "";
  width = 350;

  mounted() {
    this.getMedias();
    this.onResize();
  }

  onResize() {
    this.width = document.documentElement.clientWidth;
  }

  addMedia(media: Media) {
    this.medias.unshift(media);
  }

  @Watch("search")
  searchMedia() {
    this.page = 0;
    this.getMedias();
  }

  getNext() {
    if (this.medias.length > 0 && !this.endPage) {
      this.page += 1;
      this.getMedias(true);
    }
  }

  getMedias(next = false) {
    this.loading = true;
    this.endPage = false;
    axios
      .get("/api/media", {
        params: {
          search: this.search,
          full: next ? undefined : "true",
          page: this.page
        }
      })
      .then(r => r.data)
      .then((medias: Media[]) => {
        if (medias.length === 0) {
          this.endPage = true;
        }
        if (next) {
          this.medias = this.medias.concat(medias);
        } else {
          this.medias = medias;
        }
        this.loading = false;
      });
  }
}
